export function FV() {
  return (
    <div
      id='spfv'
      className='w-full bg-primary-600 flex flex-col justify-center min-h-screen pt-[80px] pb-[120px]'
    >
      <div className='mx-auto max-w-[360px] h-full w-full grid grid-rows-[auto_1fr]'>
        <h1 className='text-center text-[32px] px-[16px] font-bold leading-[1.44] tracking-[3.2px]'>
          サプリ&スキンケア
          <br />
          生活に効くアプリ
        </h1>
        <img
          src='/images/top-sp/first-view/sp-first-view-main-pic-full.webp'
          alt='first-view-main-pic'
          className='mx-auto max-h-[max(calc(100vh-350px),250px)] object-contain mt-[18px]'
        />
        <img
          alt='swe logo'
          src='/images/assets/swe_logo@sp.png'
          className='w-[144px] object-contain mx-auto'
        />
      </div>
    </div>
  )
}
